import { render } from "./BankAccountContainer.vue?vue&type=template&id=429f4b54"
import script from "./BankAccountContainer.vue?vue&type=script&lang=js"
export * from "./BankAccountContainer.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__